import React from "react";
import TimeAgo from "react-timeago";
import StaffProfileCard from "../../../Staff/partials/StaffProfileCard";

const PatientRiskList = ({ items = [] }) => {
	if (items.length < 1)
		return (
			<div className="text-center text-pink">
				<i className="material-icons" style={{ fontSize: "4em" }}>
					info
				</i>
				<br />
				<strong>No Risk has been recorded this patient</strong>
			</div>
		);
	return (
		<div className="no-pad table-responsive">
			<table className="table table-inbox table-hover table-bordered">
				<thead>
					<tr>
						<th className="text-center">SN</th>
						<th>Risk</th>
						<th>Staff</th>
						<th>Date Created</th>
					</tr>
				</thead>
				<tbody>
					{items.map((item, index) => (
						<tr key={index}>
							<td className="inbox-small-cells text-center">
								{index + 1}
							</td>
							<td className="view-message">
								<span>{item.risk}</span>
								<br />
								<small className="text-muted">
									<TimeAgo date={item.created_at}></TimeAgo>
								</small>
							</td>

							<td className="view-message">
								<StaffProfileCard item={item.author} />
							</td>
							<td className="view-message">
								{Intl.DateTimeFormat("en-GB", {
									month: "short",
									year: "numeric",
									weekday: "short",
									day: "numeric"
								}).format(new Date(item.created_at))}
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default PatientRiskList;
